<template>
  <div class="select-list">
    <input
        ref="inputField"
        type="text"
        v-model="filterText"
        placeholder="Type to filter..."
        class="select-list__input"
        @click.stop
    />
    <div v-for="item in filteredItems"
         :id="`test-item-${item.name.toLowerCase().replace(' ', '-')}`"
         :key="item.id"
         @click="$emit('onSelect', item)"
         class="select-list__item"
         :class="{active: active && active.id === item.id}">
      {{ item.name }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'BaseSelectList',
  props: {
    items: {
      type: Array,
      required: true,
    },
    active: {
      type: Object,
    },
  },
  data() {
    return {
      filterText: '',
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item =>
          item.name.toLowerCase().includes(this.filterText.toLowerCase()));
    },
  },
  mounted() {
    this.$refs.inputField.focus();
  },
};
</script>
<style lang="scss" scoped>
.select-list {
  position: absolute;
  z-index: 10;
  display: block;
  background-color: white;
  border-radius: 0.5rem;
  top: 100%;
  left: 0;
  min-height: 12rem;
  max-height: 80rem;
  overflow-y: auto;
  width: 100%;
  min-width: 10rem;
  box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15), 0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);

  &__input {
    width: calc(100% - 2rem);
    margin: 1rem;
    padding: 0.8rem 0.6rem;
    font-size: 1.2rem;
    border: none;
    border-bottom: 1px solid #bbb;

    &::placeholder {
      color: #bbb;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    height: 5rem;
    color: $dark-accent;
    font-weight: 500;
    font-size: 1.2rem;
    padding: 0 1.5rem;
    transition: all 0.2s;

    &.active {
      color: $company-color;
    }

    &:hover {
      background-color: darken(white, 3%);
    }
  }
}
</style>
